// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","ThankYou":"ThankYou","module":"module","message":"message","FadeIn":"FadeIn","close":"close","header":"header","body":"body","flowers":"flowers","funeralHome":"funeralHome","link":"link","shares":"shares","group":"group","icon":"icon","facebook":"facebook","twitter":"twitter","email":"email","buttonContainer":"buttonContainer"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Person/components/GuestBook/css/ThankYou.styl
// module id = 1633
// module chunks = 0